<template>
  <div class="exhibition">
    <!-- <tabbar></tabbar> -->
    <activitylist
      v-if="more"
      :activityType="activityType"
      :exhibitionType="activeName"
    ></activitylist>

    <div class="activity-list exhibition-list" v-if="!more">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="常设展览" name="常设展览">
          <div class="top-title">
            <span>|{{ activeName }}</span>
            <span class="fr" @click="showMore()">更多</span>
          </div>
          <div class="activity" v-for="(item, index) in dataList">
            <div class="homeimg">
              <img :src="getImage(item.image)" width="100%" height="100%" />
            </div>
            <div class="title">
              <p>{{ item.activityName }}</p>
              <el-button round class="fr" @click="addActive(index, item)"
                >报名</el-button
              >
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="临时展览" name="临时展览">
          <div class="top-title">
            <span>|{{ activeName }}</span>
            <span class="fr" @click="showMore()">更多</span>
          </div>
          <div class="activity" v-for="(item, index) in dataList">
            <div class="homeimg">
              <img :src="getImage(item.image)" width="100%" height="100%" />
            </div>
            <div class="title">
              <p>{{ item.activityName }}</p>
              <el-button round class="fr" @click="addActive(index, item)"
                >报名</el-button
              >
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <float v-show="isToken"></float>
      <statistics></statistics>
    </div>
  </div>
</template>
<script>
import statistics from '../components/statistics.vue'
export default {
  name: "exhibition",
  components: {statistics},
  data() {
    return {
      //分页功能
      totalPage: [],
      pageSize: 5, // 每页显示数量
      pageNum: 0, // 共几页
      dataList: [], // 当前显示的数据
      currentPage: 1, // 默认当前显示第一页
      isToken: true, //url中是否有token
      more: false, //是否展示更多展览活动
      activeName: "常设展览",
      activityType: "展览预约" //活动类型
    };
  },
  methods: {
    getQueryStringRegExp: function getQueryStringRegExp(name) {
      var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(location.href))
        return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
    getImage(val) {
      // alert(val)
      let imgArr = val.split(";");
      // alert(imgArr[0])
      return window.SITE_CONFIG.fileBaseApi + imgArr[0];
    },
    addActive(index, item) {
      this.$router.push({
        path: `/things/${item.id}`
      });
    },
    getitemList() {
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
            "/api/activity/web/activity?page=" +
            this.currentPage +
            "&limit=" +
            this.pageSize +
            "&exhibitionType=" +
            encodeURI(this.activeName) +
            "&museumCode=" +
            this.$store.state.museumCode,
          {}
        )
        .then(response => {
          var result = response.data;
          this.dataList = response.data.data.rows;
          this.pageNum = response.data.data.total;
        });
    },
    showMore() {
      this.more = true;
    }
  },
  mounted() {
    this.$nextTick(() => {
      //如果获取到小程序传来的token
      if (this.$store.state.token) {
        this.isToken = false;
      } else {
        this.isToken = true;
      }
      this.getitemList();
    });
    document.body.style.backgroundColor = "#fff";
  },
  watch: {
    activeName() {
      this.getitemList();
    }
  }
};
</script>
<style lang="scss">
.exhibition {
  .exhibition-list {
    .el-tabs__item {
      width: 3.733rem !important;
      margin-right: 1.5rem !important;
    }
  }

  .activity {
    &:first-of-type {
      margin-top: 0.667rem !important;
    }
  }
  .top-title {
    margin-top: 0.653rem;
    margin-bottom: -0.8rem;
    span {
      &:nth-child(1) {
        font-size: 0.533rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.533rem;
        letter-spacing: 0.053rem;
        color: #414987;
      }
      &:nth-child(2) {
        font-size: 0.4rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.533rem;
        letter-spacing: 0.04rem;
        color: #999999;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/exhibition.vue